

import { useState } from "react";
import { toast } from "react-toastify";
import { profileActivityJava } from "../javaAxiosConfig";

export const useProfileActions = ({ setProfiles }) => {
  const [actionLoading, setActionLoading] = useState({
    profileId: null,
    action: null,
  });

  const isActionLoading = (profileId, action) =>
    actionLoading.profileId === profileId &&
    actionLoading.action === action;

  const handleAction = async ({ user_id, response_type }, actionKey) => {
    setActionLoading({ profileId: user_id, action: actionKey });

    try {
      const response = await profileActivityJava({ user_id, response_type });
      const { status, message } = response.data;

      if (status) {
        toast.success(message);

        setProfiles((prev) =>
          prev.map((p) => {
            if (p.id !== user_id) return p;

            switch (response_type) {
              case "interest":
                return { ...p, interestSent: true };
              case "accept":
                return { ...p, interestAccepted: true };
              case "reject":
                return { ...p, interestReceived: false, received: null };
              case "remove_ignore":
                return { ...p, isIgnored: false, ignored: null };
              default:
                return p;
            }
          })
        );
      } else {
        toast.error(message);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Something went wrong");
    } finally {
      setActionLoading({ profileId: null, action: null });
    }
  };

  const handleIgnore = async (profile) => {
    setActionLoading({ profileId: profile.id, action: "IGNORE" });

    try {
      const response = await profileActivityJava({
        user_id: profile.id,
        response_type: "ignored",
      });

      if (response.data?.status) {
        toast.success(response.data.message);
        setProfiles((prev) => prev.filter((p) => p.id !== profile.id));
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Something went wrong");
    } finally {
      setActionLoading({ profileId: null, action: null });
    }
  };

  return {
    handleAction,
    handleIgnore,
    isActionLoading,
  };
};
